import { connect } from 'react-redux'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { bindActionCreators } from 'redux'
import isEmpty from 'lodash/isEmpty'

import { actionCreators } from '@/checkout-instore-legacy/order/actions'
import { getSummaryTotals } from '@/checkout-instore-legacy/summary/utils'
import CartSummary from '../components/CartSummary'
import { shippingWasFilledSelector } from '@/checkout-instore-legacy/metadata/selectors'

const mapStateToProps = (state) => {
  const orderFormTotals = getSummaryTotals(state.order.orderForm)
  const summaryTotals = isEmpty(orderFormTotals)
    ? {}
    : {
        ...orderFormTotals,
        giftCardPromise: state.returnExchange.giftCardPromise,
      }

  return {
    ...summaryTotals,
    shippingWasFilled: shippingWasFilledSelector(state),
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CartSummary)
)
